import template from "./template_crud";

const journal = '/journal'
export const getProjectJournal = template.getProjectId(journal)
export const addProjectJournal = template.postProjectId(journal)
export const updProjectJournal = template.putProjectId(journal)
export const delProjectJournal = template.deleteProjectById(journal)

export const getProjectJournalById = {
  path: (obj) => `/projects/${obj.idProject}${journal}/${obj.id}`,
  type: 'GET'
}
export const getProjectJournalRow = {
  path: (obj) => `/projects/${obj.idProject}${journal}/${obj.id}/records`,
  type: 'GET'
}
export const getProjectJournalPrint = {
  path: (obj) => `/projects/${obj.idProject}${journal}/${obj.id}/print`,
  type: 'GET'
}
export const postProjectJournalRow = {
  path: (obj) => `/projects/${obj.idProject}${journal}/${obj.id}`,
  type: 'POST'
}
export const getProjectJournalRowById = {
  path: (obj) => `/projects/${obj.idProject}${journal}/${obj.idJournal}/${obj.id}`,
  type: 'GET'
}
export const updProjectJournalRowById = {
  path: (obj) => `/projects/${obj.idProject}${journal}/${obj.idJournal}/${obj.id}`,
  type: 'PUT'
}
export const deleteProjectJournalRowById = (idProject, idJournal) => ({
  path: (obj) => `/projects/${idProject}${journal}/${idJournal}/${obj.id}`,
  type: 'DELETE'
})